import { MarketingChannel, SourceType } from './generated/api';

export const getExternalDetailLink = (
  source?: SourceType,
  carId?: string,
  offerId?: string,
  marketingChannel?: MarketingChannel[],
) => {
  switch (source) {
    case SourceType.Autobid:
      return `https://autobid.de/?action=car&id=${carId}&show=car`;
    case SourceType.Vwfs:
      return `https://usedcars.vwfs.com/vehicles/detail/${carId}`;
    case SourceType.Arval:
      return `https://remktg.arval.com/desktop2/#/item-details/${carId}?prov=se&salesEventId=${offerId}`;
    case SourceType.Okcars:
      return 'https://app.logicauto.es/';
    case SourceType.Autorola:
      return `https://www.autorola.de/dealer/bid.do?zz=1&eid=${carId}&aid=${offerId}`;
    case SourceType.Auto1:
      return `https://www.auto1.com/de/app/merchant/car/${carId}`;
    case SourceType.AudiUcp: {
      // Links differ by marketingChannel
      const parts = offerId?.split('_') ?? [];
      if (marketingChannel?.includes(MarketingChannel.Fixed)) {
        const marketItemId = parts[0];
        return `https://ucp.vwapps.run/retail/market/${marketItemId}`;
      }
      if (marketingChannel?.includes(MarketingChannel.Bid)) {
        const [auctionId, auctionLotId] = parts;
        return `https://ucp.vwapps.run/retail/auctions/${auctionId}/${auctionLotId}`;
      }
      return null;
    }
    case SourceType.Ppn:
      return `https://auctions.b2b-pag.aws.platform.porsche.cloud/auctions/${offerId}`;
    default:
      return null;
  }
};

export const getExternalPackageLink = (source?: SourceType, packageId?: string, carId?: string, offerId?: string) => {
  switch (source) {
    case SourceType.Vwfs:
      return `https://usedcars.vwfs.com/vehicles/vehicle-list/stockList?packageId=${packageId}`;
    case SourceType.AudiUcp: {
      const [auctionId, auctionLotId] = offerId?.split('_') ?? [];
      return `https://ucp.vwapps.run/retail/auctions/${auctionId}/${auctionLotId}/${carId}`;
    }
    default:
      return null;
  }
};
